import axios from "axios";
import React, { useState, useEffect } from "react";
import Loading from "../../../utilities/Loading";

export default function ServiceCharges() {
  const [charges, setCharges] = useState({
    _id: "",
    delivery_1_fee: "",
    delivery_2_fee: "",
    delivery_7_fee: "",
    delivery_15_fee: "",
    delivery_30_fee: "",
    service_fee: "",
    commission: "",
    charges: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      const response = await axios.get("/api/checkout/6088240787ea8208fcb85863");
      if (isMounted) {
        setCharges(response.data);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const onChangeText = ({ target }) => {
    const { name, value } = target;
    setCharges((prevState) => ({ ...prevState, [name]: value }));
  };

  const done = async () => {
    setLoading(true);
    const response = await axios.put(
      "/api/checkout/6088240787ea8208fcb85863",
      charges
    );
    if (response.status === 200) {
      setLoading(false);
      alert("Charges updated");
    }
  };

  return !loading ? (
    <div className="ibox-content">
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group">
            <label>
              Commission <strong className="text-danger">*</strong>
            </label>
            <div className="input-group m-b">
              <div className="input-group-prepend">
                <span className="input-group-addon">%</span>
              </div>
              <input
                type="text"
                className="form-control"
                defaultValue={charges.commission}
                name="commission"
                onChange={onChangeText}
              />
              <div className="input-group-append">
                <span className="input-group-addon">.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Commission */}
      {[1, 2, 7, 15, 30].map((meals) => (
        <div className="row" key={meals}>
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                Delivery Fee ({meals} Meals){" "}
                <strong className="text-danger">*</strong>
              </label>
              <div className="input-group m-b">
                <div className="input-group-prepend">
                  <span className="input-group-addon">$</span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  name={`delivery_${meals}_fee`}
                  onChange={onChangeText}
                  defaultValue={charges[`delivery_${meals}_fee`]}
                />
                <div className="input-group-append">
                  <span className="input-group-addon">.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      {/* Delivery Meals */}
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group">
            <label>
              Service Charges <strong className="text-danger">*</strong>
            </label>
            <div className="input-group m-b">
              <div className="input-group-prepend">
                <span className="input-group-addon">%</span>
              </div>
              <input
                type="text"
                className="form-control"
                defaultValue={charges.service_fee}
                name="service_fee"
                onChange={onChangeText}
              />
              <div className="input-group-append">
                <span className="input-group-addon">.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Service Charges */}
      <div className="row">
        <div className="col-lg-12">
          <div className="form-group">
            <label>
              Taxes <strong className="text-danger">*</strong>
            </label>
            <div className="input-group m-b">
              <div className="input-group-prepend">
                <span className="input-group-addon">%</span>
              </div>
              <input
                type="text"
                className="form-control"
                defaultValue={charges.taxes}
                name="taxes"
                onChange={onChangeText}
              />
              <div className="input-group-append">
                <span className="input-group-addon">.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Taxes */}
      <div className="d-flex justify-content-end">
        <button type="button" className="btn btn-default mr-2">
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={done}
        >
          Update
        </button>
      </div>
    </div>

  ) : (
    <Loading />
  );
}
